import { useDispatch } from 'react-redux';
import { setEnrollmentPermissionDetails } from '@actions/memberPortal/enrollmentsActionCreators';
import { setSideNavdetails } from '@actions/SideNav/sideNavActionCreators';
import { IEnrollmentDetail, IMenuPermissions } from '@modules/members/enrollments/common/types';
import useSetSelectedEnrollment from './useSetSelectedEnrollment';

export const useSetSideNavDetailsFromEnrollment = () => {
    const dispatch = useDispatch();
    const setSelectedEnrollment = useSetSelectedEnrollment();

    const checkMenuPermissions = (permissions: IMenuPermissions) => {
        const result: { [key: string]: string } = {};
        for (const key in permissions) {
            if (Object.prototype.hasOwnProperty.call(permissions, key)) {
                result[key] = permissions[key] ? 'true' : 'false';
            }
        }
        return result;
    };

    const permissionString = (obj: Record<string, any>) => {
        return JSON.stringify(obj).replace(/:/g, '=').replace(/,/g, ', ').replace(/"/g, '');
    };

    const setSessionStorage = (data: any, menuPermissions: any) => {
        sessionStorage.setItem('householdFirstName', data.hhFirstName);
        sessionStorage.setItem('householdLastName', data.hhLastName);
        sessionStorage.setItem('householdId', data.hhId);
        sessionStorage.setItem('permissionMap', permissionString(menuPermissions));
        sessionStorage.setItem('encHouseHoldId', data.encHHId);
    };

    return (EnrollmentDetails: IEnrollmentDetail) => {
        const enrollment = JSON.parse(EnrollmentDetails.enrollmentDetail);
        const menuPermissions = checkMenuPermissions(EnrollmentDetails.menuPermissions);
        const data = {
            hhFirstName: EnrollmentDetails?.household.firstName,
            hhLastName: EnrollmentDetails?.household.lastName,
            hhId: EnrollmentDetails?.householdId,
            permissionMap: menuPermissions,
            encHHId: EnrollmentDetails?.encHouseholdId,
        };
        dispatch(setSideNavdetails(data));
        setSessionStorage(data, EnrollmentDetails.menuPermissions);
        setSelectedEnrollment(enrollment);
        dispatch(setEnrollmentPermissionDetails({ userPermissions: EnrollmentDetails?.enrollmentPermissions }));
    };
};
